<template>
  <v-card class="d-flex flex-column pa-3 pt-0" light height="420px">
    <v-card-text class="pb-0 px-6">
      <v-list>
        <v-row justify="center">
          <v-col class="px-1">
            <p class="pb-6 px-0">
              {{ $t("Generate an image snapshot. Select date and time to generate the snapshot.") }}
            </p>
            <v-menu ref="menu" v-model="dateMenu" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  :label="$t('Select date')"
                  prepend-icon="fa fa-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-if="dateMenu" v-model="date" no-title scrollable :max="today"> </v-date-picker>
            </v-menu>
            <v-menu
              ref="menu2"
              v-model="timeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="time"
                  :label="$t('Select time')"
                  prepend-icon="fa fa-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeMenu"
                v-model="time"
                format="24hr"
                use-seconds
                @click:second="$refs.menu2.save(time)"
              ></v-time-picker>
            </v-menu>
            <v-checkbox
              class="black-label-text"
              hide-details
              v-model="includeTimestamp"
              :label="$t('Include date and time in exported snapshot')"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-list>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed @click="getSnapshot" color="primary">{{ $t("Export") }}</v-btn>
      <v-btn depressed @click="closeOverlay">{{ $t("Close") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { reactive, toRefs, computed } from "../../plugins/compositionApi";
import restapi from "../../service/CMApi";
import { store } from "@/store/index";
import { t } from "../../service/locale";
import { saveFile } from "../../service/main";

export default {
  name: "SnapshotTimeStamp",
  props: {
    camera: {
      type: Object,
    },
    currentTime: Number,
    showDialog: Boolean,
    offset: Number,
    rights: Object,
    resolution: String,
    showOnlySnap: Boolean,
  },
  setup(props, context) {
    const data = reactive({
      time: new Date((props.showOnlySnap ? Date.now() : props.currentTime) - props.offset).toTimeString().substr(0, 8),
      date: new Date(props.currentTime - props.offset).toISOString().substr(0, 10),
      milliseconds: props.currentTime.toString().slice(-3),
      dateFormatted: computed(() => formatDate(new Date(props.currentTime - props.offset).toISOString().substr(0, 10))),
      timeMenu: false,
      dateMenu: false,
      day: 86400000,
      today: computed(() => new Date().toISOString()),
      includeTimestamp: false,
    });

    const { getSnapshot, closeOverlay, formatDate } = useSnapShotOverlay(data, context, props);

    return { ...toRefs(data), getSnapshot, closeOverlay, formatDate };
  },
};

function useSnapShotOverlay(data, context, props) {
  async function getSnapshot() {
    if (props.rights && props.rights.demoUser) {
      return store.dispatch("demoMessage");
    }
    try {
      let time = new Date(new Date(`${data.date}T${data.time}`).getTime() + props.offset)
        .toISOString()
        .replace("Z", "+0000")
        .replace("000", data.milliseconds);
      let image = await restapi.getSnapshot(props.camera.cameraId, props.resolution, time, data.includeTimestamp);
      saveFile(image, `${props.camera.name}_Snapshot.jpg`);
    } catch (error) {
      store.dispatch("toastMessage", {
        showing: true,
        text: this.$t(`No snapshot found or there was an error downloading the snapshot. Please try again.`),
        timeout: -1,
        color: "error",
        support: true,
      });
    }
  }

  function closeOverlay() {
    context.emit("close");
  }

  function formatDate() {
    if (!data.date) return null;
    const [year, month, day] = data.date.split("-");
    return `${year}/${month}/${day}`;
  }

  return { getSnapshot, closeOverlay, formatDate };
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

.custom-tooltip {
  background-color: $primary;
  color: white;
  border-radius: 3px;
  padding: 1px 4px 0 4px;
  text-align: center;
  // white-space: pre;
}
.custom-label {
  width: 60px;
  white-space: pre-wrap;
  text-align: center;
}
.custom-label.active {
  color: #3498db;
}
.black-label-text {
  &::v-deep label {
    color: #555555;
    font-size: 14px;
  }
}
.overlay-z {
  z-index: 1000 !important;
}
</style>
